module.exports = "<div class=\"nointernetconnection\" *ngIf != \"isOnline\">\n    {{internet_check}} {{today | date:'hh:mm a'}} on {{today | date}}\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/no-internet/no-internet.component.html
// module id = ./src/app/no-internet/no-internet.component.html
// module chunks = main